import File02 from '@untitled-ui/icons-react/build/esm/File02';

import { useLazyGetEntityStatusReportPdfQuery } from 'api/EntitiesApiSlice';
import { useToast } from 'providers/ToastProvider';
import { BaseButton } from './BaseButton';

interface DownloadVerificationConfirmationButtonProps {
  entityId?: string;
  registeredName?: string | null;
}

export const DownloadVerificationConfirmationButton = ({
  entityId,
  registeredName,
}: DownloadVerificationConfirmationButtonProps) => {
  const [getEntityStatusReportPdf, { isFetching }] = useLazyGetEntityStatusReportPdfQuery();
  const toast = useToast();

  const handleDownloadPdf = async () => {
    if (!entityId) {
      toast.warning('No verification found for this group.');
      return;
    }

    try {
      const { blob } = await getEntityStatusReportPdf(entityId).unwrap();

      const filename = `${registeredName || 'verification'}-status-report.pdf`;

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      toast.error('Failed to download verification PDF.');
    }
  };

  return (
    <BaseButton
      className="secondary-button"
      icon={<File02 className="h-4 w-4" />}
      loading={isFetching}
      onClick={handleDownloadPdf}
    >
      Verification Confirmation
    </BaseButton>
  );
};

export default DownloadVerificationConfirmationButton;
